export const bankStatusOptions = [
  { value: 1001, label: 'Active' },
  { value: 1002, label: 'Inactive' },
];

export const bankValueTypeLabels = {
  number: 'Định dạng số',
  phone: 'Định dạng số điện thoại',
  phone_or_number: 'Định dạng số hoặc số điện thoại',
  string: 'Định dạng mã tự do (số và ký tự)',
};
